// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconSocialX = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M104,0 C110.075132,0 115,4.92486775 115,11 C115,17.0751322 110.075132,22 104,22 C97.9248678,22 93,17.0751322 93,11 C93,4.92486775 97.9248678,0 104,0 Z M101.612994,5 L97.5,5 L102.412429,11.5625 L97.7542373,17 L99.7514124,17 L103.344633,12.8057692 L106.488701,17 L110.5,17 L105.375706,10.0826923 L109.731638,5 L107.737288,5 L104.451977,8.83365385 L101.612994,5 Z M101.011299,6.15384615 L108.141243,15.7826923 L107.036723,15.7826923 L99.8248588,6.15384615 L101.011299,6.15384615 Z"
                transform="translate(-93)"
            />
        </svg>
    );
};

export default React.memo(IconSocialX);
